module.exports = "/_next/static/media/f23de96d4743350a95ae84d2ade23148.png";